import { helpers } from './theme/helpers.js';
import { sliders } from './theme/components/sliders.js';
import { headerMenu } from './theme/components/header-menu.js';
import { prepositions } from './theme/components/prepositions.js';
import { block_video } from './theme/blocks/video.js';
import { block_projects } from './theme/blocks/projects.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
	},

	helpers: helpers,

	// Funkce pro kontrolu a přidání animací
	checkScrollAnimations: function() {
		jQuery('.block-cool-text__stars, .bubble, .brand-building-motion, .content-marketing-motion, .creative-campaings-motion, .customer-experience-motion, .production-motion   ').each(function() {
			var $element = jQuery(this);
			
			// Kontrola, zda element ještě nemá třídu (aby se animace nespustila vícekrát)
			if (!$element.hasClass('start-animation')) {
				if (theme.helpers.isOnScreen($element)) {
					$element.addClass('start-animation');
				}
			}
		});
	},
	

splitHeadingsAOS: function(selector = '.block-services h2, .block-cool-text__inner') {
  const splitBR = (html) => html.split(/<br\s*\/?>/i);

  document.querySelectorAll(selector).forEach((el) => {
    if (el.dataset.aosSplitDone) return;

    const paragraphs = Array.from(el.querySelectorAll('p'));

    if (paragraphs.length) {
      // Rodič s více <p> → navazující delay napříč všemi odstavci
      let counter = 0;
      paragraphs.forEach((p) => {
        const parts = splitBR(p.innerHTML);
        p.innerHTML = parts
          .map((part) => {
            const delay = (++counter) * 150;
            return `<span data-aos="zoom-in-up" data-aos-delay="${delay}">${part.trim()}</span>`;
          })
          .join('<br>');
      });
    } else {
      // Jednoduchý element (např. H2) → zpracuj přímo jeho obsah
      const parts = splitBR(el.innerHTML);
      el.innerHTML = parts
        .map((part, i) => {
          const delay = (i + 1) * 150;
          return `<span data-aos="zoom-in-up" data-aos-delay="${delay}">${part.trim()}</span>`;
        })
        .join('<br>');
    }

    el.dataset.aosSplitDone = '1';
  });

  if (window.AOS && typeof window.AOS.refresh === 'function') {
    window.AOS.refresh();
  }
},



	// Inicializace scroll animací
	initScrollAnimations: function() {
		var self = this;
		
		// Kontrola při načtení
		self.checkScrollAnimations();
		
		// Kontrola při scrollování s throttling
		jQuery(window).on('scroll', helpers.throttle(function() {
			self.checkScrollAnimations();
		}, 100));
		
		// Kontrola při změně velikosti okna
		jQuery(window).on('resize', helpers.throttle(function() {
			self.checkScrollAnimations();
		}, 250));
	},
	ppl_change: function() {
		const list = document.querySelector(".block-people__inner ul");

		// pokud seznam vůbec neexistuje, skončíme
		if (!list) return;

		const items = list.querySelectorAll("li");
		if (!items.length) return;

		// Vytvoříme pole čísel 0..n-1 a promícháme
		const orders = [...Array(items.length).keys()]
			.sort(() => Math.random() - 0.5);

		items.forEach((item, index) => {
			item.style.order = orders[index];
		});
	},

	init: function () {
		var self = this;

		// Inicializace helpers
		helpers.init();

		// Inicializace komponent
		sliders.init();
		headerMenu.init();
		prepositions.init();

		// Inicializace bloků
		block_video.init();
		block_projects.init();

		// Inicializace scroll animací
		self.initScrollAnimations();

		self.splitHeadingsAOS();

		self.ppl_change();

		
		AOS.init({
			once: true
		});
		console.log("asd");
	},
};

jQuery(document).ready(function ($) {
	theme.init();


});